import React, { useEffect, useRef, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import { storeIdAction } from "../../../redux/actions/general-action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { storeDetailsAction } from "../../../redux/actions/invoices-action";
import successToast from "../../helper-components/success-toast";
import errorToast from "../../helper-components/error-toast";
import { useFormikContext } from "formik";
import {
  purchaseCreateAction,
  purchaseEditAction,
  uploadPoCsvAction,
} from "../../../redux/actions/purchase-action";

import moment from "moment";

import { handlea4Print } from "../../helper-components/helper-function";
import Papa from "papaparse";
import SalesPurchaseNavbar from "../../sales-section/sales-purchase-navbar";
import SalesPurchaseFooter from "../../sales-section/sales-purchase-footer";
import PurchaseOrderItemsSec from "./purchase-items-table";
import PurchaseCreditNotePanel from "../goods-receipt/purchase-cr-db-notes-panel";
function DirtyWatcher({ onChange }) {
  const { dirty } = useFormikContext();
  useEffect(() => {
    onChange(!!dirty);
  }, [dirty, onChange]);
  return null;
}
const CreateEditViewPur = ({
  isClone = false,
  type = "",
  orderDetail = [],
  vendorDetails = [],
  disabled = false,
  page = "",
  data,
  payto,
  shipto,
  pageType,
  clickedplus,
  setEnableConfirm,
  toValidate,
  transfer=false
}) => {
  const [heading, setHeading] = useState([]);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const isDispatchingRef = useRef(false);
  const submitScheduledRef = useRef(false);
  const rowData = useSelector((state) => state.invoiceRowReducer);
  const searchRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const initialData = {
    sl_no: 1,
    item_name: "",
    item_generic_name: "",
    molecule_name: "", //new
    mrp: "", //new
    item_baby_box_packing: "", //new

    item_request_quantity: 0, //new
    item_purchase_return: "-", //new
    item_batch_total_base_purchase_rate: "", //new
    item_total_tax_percentage: 0, //new
    item_tax_amount: 0, //new
    item_discount_amount: 0, //new
    item_discount_percentage: 0, //new
    item_code: "",
    item_manufacturer_name: "",
    item_return_availability: "",
    item_uom: "",
    total_sellable_quantity: 0,
    quantity: 0,
    item_unit_price: 0,
    item_min_max: "",
    item_total_amount: 0,
    item_id: "",
    item_tax_amount: 0,
    item_gst: 0,
    item_sgst: 0,
    item_cgst: 0,
    item_igst: 0,
    item_price_wiithout_tax: 0,
    item_uom_id: "",
    item_minimun_purchasing: "",
    item_maximum_purchasing: "",
    item_pur_min_uom_quantity: "0",
  };
  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_phone_number: vendorDetails?.[0]?.cmr_phone_number ?? "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    remarks: vendorDetails?.[0]?.remarks ?? "",
    pot_order_date: vendorDetails?.[0]?.pot_order_date && !isClone
      ? moment(vendorDetails?.[0]?.pot_order_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    pot_document_date: vendorDetails?.[0]?.pot_document_date && !isClone
      ? moment(vendorDetails?.[0]?.pot_document_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    pot_delivery_date: vendorDetails?.[0]?.pot_delivery_date && !isClone
      ? moment(vendorDetails?.[0]?.pot_delivery_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    pot_reference_inv_date: vendorDetails?.[0]?.pot_reference_inv_date && !isClone
      ? moment(vendorDetails?.[0]?.pot_reference_inv_date).format("YYYY-MM-DD")
      : moment(new Date()).format("YYYY-MM-DD"),
    cmr_gstin: vendorDetails?.[0]?.cmr_gstin ?? "",
    pot_order_status: vendorDetails?.[0]?.pot_order_status ?? "",
    pot_total_discount: vendorDetails?.[0]?.pot_total_discount ?? 0,
    pot_sub_total: vendorDetails?.[0]?.pot_sub_total ?? 0,
    pot_total_amount: vendorDetails?.[0]?.pot_total_amount ?? 0,
    pot_total_gst: vendorDetails?.[0]?.pot_total_gst ?? 0,
    pot_round_off_value: vendorDetails?.[0]?.pot_round_off_value ?? 0,
    pot_pay_to_address: payto, //new
    pot_ship_to_address: shipto, //new
    customer_invoice_number:
      vendorDetails?.[0]?.customer_invoice_number ?? null,
    ...(!isClone && vendorDetails?.[0]?.pot_id
      ? { pot_id: vendorDetails?.[0]?.pot_id }
      : {}),
    pot_id: isClone ? null : (vendorDetails?.[0]?.pot_id ?? orderDetail?.[0]?.pot_id ?? null),
    pos_id: vendorDetails?.[0]?.pos_id ?? orderDetail?.[0]?.pos_id ?? null,
    is_inter_state:vendorDetails?.[0]?.gst_type === "Inter"?true:vendorDetails?.[0]?.gst_type === "Intra"?false:null,
    creditNoteData: [],
    claimed_adjusted: vendorDetails?.[0]?.claimed_adjusted ?? "0.00",
    ledger_closing: vendorDetails?.[0]?.ledger_closing ?? "0.00",
    pcn_net_balance: vendorDetails?.[0]?.pcn_net_balance ?? "0.00",
    pcns_total: vendorDetails?.[0]?.pcns_total ?? "0.00",
    remaining_balance: vendorDetails?.[0]?.remaining_balance ?? "0.00",
    data: [
      ...orderDetail?.map((item, index) => ({
        selected_uom_qty: 0, //new
        item_pur_min_uom_quantity: item?.item_pur_min_uom_quantity ?? "", //new
        sl_no: index + 1,
        item_name: item?.item_name ?? "",
        item_generic_name:
          item?.item_generic_name === null ? "" : item?.item_generic_name,
        molecule_name: item?.molecule_name ?? "", //new
        mrp: item?.mrp ?? "", //new
        item_purchase_return: item?.item_purchase_return
          ? item?.item_purchase_return === true
            ? "N"
            : "Y"
          : "Y", //new
        item_baby_box_packing: item?.item_baby_box_packing, //new
        item_batch_total_base_purchase_rate:
          item?.item_batch_total_base_purchase_rate, //new
        item_total_tax_percentage: item?.item_total_tax_percentage ?? 0, //new
        item_tax_amount: item?.item_tax_amount ?? 0, //new
        item_discount_amount: item?.item_discount_amount ?? 0, //new
        item_discount_percentage: item?.item_discount_percentage ?? 0, //new
        item_request_quantity: item?.item_request_quantity ?? 0,
        item_code: item?.item_code ?? "",
        item_manufacturer_name: item?.item_manufacturer_name,
        item_return_availability: "--",
        item_uom: item?.item_uom ?? "--",
        total_sellable_quantity: item?.total_sellable_quantity,
        quantity: item?.item_quantity ?? item?.item_requested_quantity ?? 0,
        item_unit_price: item?.item_unit_price ?? 0,
        item_min_max: item?.item_min_max,
        item_total_amount: item?.item_total_amount,
        item_id: item?.item_id,
        item_tax_amount: item?.item_tax_amount,
        instock: true,
        item_gst: item?.item_gst,
        item_cgst:  item?.item_cgst,
        item_sgst: item?.item_sgst,
        pot_id: isClone ? null : (vendorDetails?.[0]?.pot_id ?? null),
        pos_id: vendorDetails?.[0]?.pos_id ?? null,
        item_price_wiithout_tax:item?.item_price_wiithout_tax,
        uom_dropdown: item?.uom_dropdown
          ? item?.uom_dropdown.map((uom) => ({
              item_uom_id: uom?.item_id,
              label: uom?.alt_uom,
              value: uom?.alt_uom,
            }))
          : [],
        item_uom_id: item?.item_uom_id ?? "",
        item_manufacturer_id: item?.item_manufacturer_id ?? "",
        item_minimun_purchasing: item?.item_minimun_purchasing ?? "",
        item_maximum_purchasing: item?.item_maximum_purchasing ?? "",
        item_hsn: item.item_hsn,
      })),
      initialData,
    ],
  };
  const [initialValue, setInitialValue] = useState(initialFormValues);
  const [reload, setReload] = useState(false);
  const [formValues, setFormValues] = useState({});
  const [storeId, setStoreId] = useState("");
  const [storeDetails, setStoreDetails] = useState({});
  const [creditNotesOpen, setCreditNotesOpen] = useState(false);
  const validationSchema = Yup.object().shape({
    cmr_code: Yup.object().required("Vendor code is required"),
    cmr_name: Yup.object().required("Vendor name is required"),
    pot_document_date: Yup.string().required("Document date is required"),
    pot_delivery_date: Yup.string().required("Delivery date is required"),

    data: Yup.array().test(
      "skip-last-validation",
      "Invalid data",
      function (arr) {
        if (!arr || !Array.isArray(arr)) return true;

        // Validate all rows except the last one
        for (let i = 0; i < arr.length - 1; i++) {
          const row = arr[i];

          // Check if MRP exists and is a number
          // if (!row.mrp || isNaN(Number(row.mrp))) {
          //   errorToast(`MRP is required and must be a number for row ${i}`);
          //   return this.createError({
          //     path: `data[${i}].mrp`,
          //     message: "MRP is required and must be a number",
          //   });
          // }

          // Check if item_unit_price exists and is a number
          // if (!row.item_unit_price || isNaN(Number(row.item_unit_price))) {
          //   errorToast(`Tentative Price is required and must be a number for row ${i}`);
          //   return this.createError({
          //     path: `data[${i}].item_unit_price`,
          //     message: "Tentative Price is required and must be a number",
          //   });
          // }

          // Check if MRP >= item_unit_price
          // if (Number(row.mrp) < Number(row.item_unit_price)) {
          //   return this.createError({
          //     path: `data[${i}].mrp`,
          //     message: "MRP must be greater than or equal to Tentative Price",
          //   });
          // }
        }

        return true;
      }
    ),
  });
  useEffect(() => {
    dispatch(storeIdAction(onSuccessStore, onErrorStore));
    dispatch(storeDetailsAction(onSuccessStoreDetails, onErrorStoreDetails));
    const data = localStorage.getItem("ModPermission");
    if (data) {
      const parsed = JSON.parse(data);
      const Purdata = parsed.find((obj) => obj?.purchase_Create);
      if (Purdata?.purchase_Create) {
        setHeading(Purdata.purchase_Create);
        console.table(Purdata.purchase_Create);
      }
    }
  }, []);
  const onSuccessStore = (data) => {
    setStoreId(data?.data?.store_id);
    setReload(!reload);
  };
  const onErrorStore = () => {};
  const onSuccessStoreDetails = (data) => {
    setStoreDetails(data?.data);
    const storeData=data?.data;
    const storeState=storeData?.store_state;
    const store_state=storeState?.toLowerCase()?.trim();
    if(store_state===null || store_state===undefined || store_state?.trim()===""){
        errorToast("Please configure store state in store deatils")
        return;
    }
  };
  const onErrorStoreDetails = () => {};
  const minimumQuantityValidation = (data) => {
    let hasError = false;
    let errorMessages = [];

    const ordinalSuffixes = ["st", "nd", "rd"];

    data?.forEach((item, index) => {
      console.log(
        "qqq",
        item?.selected_uom_qty,
        item?.item_pur_min_uom_quantity,
        item?.quantity
      );
      if (
        item?.selected_uom_qty &&
        item?.item_pur_min_uom_quantity &&
        item?.quantity
      ) {
        const actualQuantity = item.selected_uom_qty * item.quantity;
        const minimumRequired = item.item_pur_min_uom_quantity;
        console.log("oooo", actualQuantity < minimumRequired);

        if (actualQuantity < minimumRequired) {
          hasError = true;
          const suffix = index < 3 ? ordinalSuffixes[index] : "th";
          const itemPosition = index + 1;

          // errorToast(
          //   `Minimum quantity of ${itemPosition}${suffix} item should be ${minimumRequired}`
          // );
          errorToast(
            `Minimum quantity of ${item.name} item should be ${minimumRequired}`
          );
        }
      }
    });
    return hasError;
  };
const handleSubmit = (values, actions) => {
  // Defense in depth: never dispatch while a request is already in flight.
  if (isDispatchingRef.current) return;

  const validation = minimumQuantityValidation(values.data);
  if (validation) return;

  // ✅ NEW: MRP missing validation (show item name)
  const mrpMissingItem = (values?.data ?? [])
    .slice(0, -1)
    .find((item) => {
      const mrpRaw = item?.mrp;
      const mrp = parseFloat(mrpRaw);
      // treat empty / null / undefined / NaN as missing
      return mrpRaw === null || mrpRaw === undefined || String(mrpRaw).trim() === "" || !Number.isFinite(mrp);
    });
  if (mrpMissingItem) {
    errorToast(`Please add MRP for item: ${mrpMissingItem?.item_name || mrpMissingItem?.item_code || "Unknown item"}`);
    return;
  }
  const tentativeMissingItem = (values?.data ?? [])
    .slice(0, -1)
    .find((item) => {
      const mrpRaw = item?.item_unit_price;
      const mrp = parseFloat(mrpRaw);
      // treat empty / null / undefined / NaN as missing
      return mrpRaw === null || mrpRaw === undefined || String(mrpRaw).trim() === "" || !Number.isFinite(mrp);
    });
  if (tentativeMissingItem) {
    errorToast(`Please add Tentative Price for item: ${tentativeMissingItem?.item_name || tentativeMissingItem?.item_code || "Unknown item"}`);
    return;
  }
  const tentativeCheck = (values?.data ?? [])
    .slice(0, -1)
    .find((item) => {
      const prRaw = item?.item_unit_price;
      const mrpRaw=item?.mrp;
      const mrp = parseFloat(mrpRaw);
      const pr=parseFloat(prRaw);
      // treat empty / null / undefined / NaN as missing
      return mrp<pr;
    });
  if (tentativeMissingItem) {
    errorToast(`Please add Tentative Price for item: ${tentativeMissingItem?.item_name || tentativeMissingItem?.item_code || "Unknown item"}`);
    return;
  }
  const mrpViolations = (values?.data ?? [])
    .slice(0, -1)
    .filter((item) => {
      const mrp = parseFloat(item?.mrp);
      const purchaseRate = Number.isFinite(parseFloat(item?.item_batch_total_base_purchase_rate))
        ? parseFloat(item?.item_batch_total_base_purchase_rate)
        : parseFloat(item?.item_unit_price);

      return Number.isFinite(mrp) && Number.isFinite(purchaseRate) && mrp <= purchaseRate;
    });

  if (mrpViolations.length > 0) {
    errorToast(
      `MRP must be greater than purchase rate for ${mrpViolations.length} item${
        mrpViolations.length > 1 ? "s" : ""
      }. Please correct and try again.`
    );
    return;
  }

  if (!values?.pot_pay_to_address) {
    errorToast("Please verify and save the address");
    return;
  }
  if (!values?.pot_ship_to_address) {
    errorToast("Please verify and save the address");
    return;
  }

  const missingUOM = values?.data?.slice(0, -1).some((item) => !item.item_uom);

  const missingTotal = values?.data
    ?.slice(0, -1)
    .some((item) => !parseFloat(parseFloat(item.item_unit_price) * parseInt(item.quantity)));

  let actionType = purchaseCreateAction;
  if (page === "edit") {
    actionType = purchaseEditAction;
  }

  if (
    values?.data
      ?.slice(0, -1)
      .some((item) => parseInt(item.quantity) === 0 || item.quantity === "") &&
    values?.submittedButton !== "draft"
  ) {
    errorToast("Quantity cannot be zero");
  } else if (missingUOM && values?.submittedButton !== "draft") {
    errorToast("Please add UOM for all items");
  } else if (missingTotal && values?.submittedButton !== "draft") {
    errorToast("Please check total for all items.");
  } else {
    if (values?.data?.length > 1) {
      isDispatchingRef.current = true;
      setButtonLoading(true);
      dispatch(
        actionType(
          {
            orderData: {
              is_draft_order: values.submittedButton === "draft" ? true : false,
              store_id: storeId,
              ...(values?.pot_id ? { pot_id: values?.pot_id } : {}),
              cmr_balance: Number(vendorDetails?.[0]?.cmr_balance) || 0,

              pot_total_gst: Number(values?.pot_total_gst) || 0,
              pot_total_discount: Number(values?.pot_total_discount) || 0,
              pot_payment_status: "paid",
              pot_transaction_id: "",
              pot_billing_address: "",
              pot_sub_total: Number(values?.pot_sub_total) || 0,
              pot_total_amount: Number(values?.pot_total_amount) || 0,
              cmr_code: values?.cmr_code?.label,
              cmr_id: values?.cmr_id,
              cmr_name: values?.cmr_name?.label,
              remarks: values?.remarks,
              pot_order_date: values?.pot_order_date,
              pot_document_date: values?.pot_document_date,
              pot_delivery_date: values?.pot_delivery_date,
              pot_reference_inv_date: values?.pot_reference_inv_date || null,
              cmr_gstin: values?.cmr_gstin || null,
              pot_round_off_value: Number(values?.pot_round_off_value) || 0,
              customer_invoice_number: values?.customer_invoice_number || "",
              pot_pay_to_address: values?.pot_pay_to_address || null,
              pot_ship_to_address: values?.pot_ship_to_address || null,
              gst_type:values?.is_inter_state===false?"Intra":"Inter",
              pot_id: values?.pot_id ?? null,
              pos_id: values?.pos_id ?? null,
            },
            itemData: values?.data?.slice(0, -1).map((item, index) => ({
              item_name: item?.item_name ?? "",
              ...(values?.pot_id ? { pot_id: values?.pot_id } : {}),
              item_id: item?.item_id,
              item_generic_name: item?.item_generic_name,
              molecule_name: item?.molecule_name ?? "",
              mrp: Number(item?.mrp) || 0,
              item_baby_box_packing: item?.item_baby_box_packing,

              item_batch_total_base_purchase_rate: Number(item?.item_batch_total_base_purchase_rate) || 0,
              item_total_tax_percentage: Number(item?.item_total_tax_percentage) || 0,
              item_tax_amount: item?.item_tax_amount ?? 0,
              item_discount_amount: Number(item?.item_discount_amount) || 0,
              item_discount_percentage: Number(item?.item_discount_percentage) || 0,

              item_code: item?.item_code ?? "",
              item_manufacturer_name: item?.item_manufacturer_name ?? "",
              item_uom: item?.item_uom ?? "--",
              item_quantity: Number(item?.quantity) || 0,
              item_unit_price: Number(item?.item_unit_price) || 0,
              item_total_amount: Number(item?.item_total_amount) || 0,
              item_minimun_purchasing: item?.item_minimun_purchasing ? parseInt(item?.item_minimun_purchasing) : "",
              item_maximum_purchasing: item?.item_maximum_purchasing ? parseInt(item?.item_maximum_purchasing) : "",
              item_tax_amount: parseFloat(item?.item_tax_amount),
              item_gst: parseFloat(item?.item_gst),
              item_sgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_sgst || 0),
              item_cgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_cgst || 0),
              item_igst: values?.is_inter_state === true ? parseFloat(item?.item_igst || item?.item_tax_amount || 0) : 0,
              item_uom_id: item?.item_uom_id ?? "",
              item_hsn: item.item_hsn,
            })),
          },
          onSuccessOrder,
          onErrorOrder
        )
      );
    } else {
      errorToast("Please add at least one item to save.");
    }
  }
};


  const onSuccessOrder = (data) => {
    isDispatchingRef.current = false;
    setButtonLoading(false);

    navigate("/purchase");
    if (formValues?.submittedButton === "print") {
      handlea4Print(data?.data?.orderData?.pot_id, "purchase_order", dispatch);
    }
    successToast(data?.message);
    setInitialValue({
      cmr_code: "",
      cmr_name: "",
      cmr_phone_number: "",
      cmr_id: "",
      remarks: "",
      pot_total_discount: 0,
      pot_order_date: null,
      pot_document_date: null,
      pot_delivery_date: null,
      data: [initialData],
    });
  };
  const onErrorOrder = (data) => {
    errorToast(data?.data?.message);
    isDispatchingRef.current = false;
    setButtonLoading(false);
  };

  const handleFileUpload = (event) => {
    const file = event?.target?.files?.[0];
    if (!file) return;
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        const parsedData = results.data;
        if (!parsedData || parsedData.length === 0 || !parsedData[0]) {
          errorToast(
            "Error: The CSV file is empty or contains no valid records."
          );
          return; // Stop further processing
        }
        //
        const expectedHeaders = [
          "item_name",
          "item_sheet_uom",
          "item_quantity",
          "item_unit_price",
          "item_total_price",
          "item_baby_box_packing",
          "molecule_name",
          "mrp",
          "item_batch_total_base_purchase_rate",
          "item_discount_percentage",
          "item_tax_percentage",
        ];
        //
        const fileHeaders = Object.keys(parsedData[0]);
        const isValidTemplate = expectedHeaders.every((header) =>
          fileHeaders.includes(header)
        );
        if (!isValidTemplate) {
          errorToast("Error: CSV template does not match the required format.");
          return;
        }
        const missingFields = parsedData.some(
          (item) => !item.item_name || item.item_name.trim() === ""
        );

        if (missingFields) {
          errorToast(
            "Error: CSV file is missing the mandatory field 'item_name'."
          );
          return;
        }

        setLoading(true);
        dispatch(
          uploadPoCsvAction(
            {
              data: parsedData,
            },
            onSuccess,
            onError
          )
        );
      },
      error: (error) => {
        errorToast("Error parsing file:", error);
      },
    });
  };

  const onSuccess = (data) => {
    navigate("/purchase-order-csv", {
      state: { suggestedProducts: data.data },
    });

    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.message);
  };

  const autoDraft = (values) => {
    if (isDispatchingRef.current) return;
    const hasItems = (values?.data?.length ?? 0) > 1;
    if (hasItems) {
      const validation = minimumQuantityValidation(values.data);
      if (validation) return;
    }
    const missingUOM = values?.data
      ?.slice(0, -1)
      .some((item) => !item.item_uom);
    const missingTotal = values?.data
      ?.slice(0, -1)
      .some(
        (item) =>
          !parseFloat(
            parseFloat(item.item_unit_price) * parseInt(item.quantity)
          )
      );
    let actionType = purchaseCreateAction;
    if (page === "edit") {
      actionType = purchaseEditAction;
    }
    if (
      hasItems &&
      values?.data
        ?.slice(0, -1)
        .some(
          (item) => parseInt(item.quantity) === 0 || item.quantity === ""
        ) &&
      values?.submittedButton !== "draft"
    ) {
      errorToast("Quantity cannot be zero");
    } else if (hasItems && missingUOM && values?.submittedButton !== "draft") {
      errorToast("Please add UOM for all items");
    } else if (hasItems && missingTotal && values?.submittedButton !== "draft") {
      errorToast("Please check total for all items.");
    } else {
      // Allow draft with or without items (e.g. Add Address without items)
      if (((values?.data?.length ?? 0) >= 0)) {
        isDispatchingRef.current = true;
        setButtonLoading(true);
        if(hasItems){
          dispatch(
            actionType(
              {
                orderData: {
                  is_draft_order: true,
                  store_id: storeId,
                  ...(values?.pot_id ? { pot_id: values?.pot_id } : {}),
                  cmr_balance: Number(vendorDetails?.[0]?.cmr_balance) || 0,

                  pot_total_gst: Number(values?.pot_total_gst) || 0,
                  pot_total_discount: Number(values?.pot_total_discount) || 0,
                  pot_payment_status: "paid",
                  pot_transaction_id: "",
                  pot_billing_address: "",
                  pot_sub_total: Number(values?.pot_sub_total) || 0,
                  pot_total_amount: Number(values?.pot_total_amount) || 0,
                  cmr_code: values?.cmr_code?.label,
                  cmr_id: values?.cmr_id,
                  cmr_name: values?.cmr_name?.label,
                  remarks: values?.remarks,
                  pot_order_date: values?.pot_order_date,
                  pot_document_date: values?.pot_document_date,
                  pot_delivery_date: values?.pot_delivery_date,
                  pot_reference_inv_date: values?.pot_reference_inv_date || null,
                  cmr_gstin: values?.cmr_gstin || null,
                  pot_round_off_value: Number(values?.pot_round_off_value) || 0,
                  customer_invoice_number: values?.customer_invoice_number || "",
                  pot_pay_to_address: values?.pot_pay_to_address || null, //new
                  pot_ship_to_address: values?.pot_ship_to_address || null, //new
                  gst_type:values?.is_inter_state===false?"Intra":"Inter",
                  pot_id: values?.pot_id ?? null,
                  pos_id: values?.pos_id ?? null,
                },
                itemData: (values?.data?.slice(0, -1) ?? []).map((item, index) => ({
                  item_name: item?.item_name ?? "",
                  item_id: item?.item_id,
                  item_generic_name: item?.item_generic_name,
                  molecule_name: item?.molecule_name ?? "", //new
                  mrp: Number(item?.mrp) || 0, //new
                  item_baby_box_packing: item?.item_baby_box_packing, //new

                  item_batch_total_base_purchase_rate:
                    Number(item?.item_batch_total_base_purchase_rate) || 0, //new
                  item_total_tax_percentage: Number(item?.item_total_tax_percentage) || 0, //new
                  item_tax_amount: item?.item_tax_amount ?? 0, //new
                  item_discount_amount: Number(item?.item_discount_amount) || 0, //new
                  item_discount_percentage: Number(item?.item_discount_percentage) || 0, //new

                  item_code: item?.item_code ?? "",
                  item_manufacturer_name: item?.item_manufacturer_name ?? "",
                  // item_return_availability: parseInt(item?.item_return_availability),
                  item_uom: item?.item_uom ?? "--",
                  item_quantity: Number(item?.quantity) || 0,
                  // total_sellable_quantity: item?.total_sellable_quantity,
                  item_unit_price: Number(item?.item_unit_price) || 0,
                  // ...(type === "sales"
                  //   ? { sales_order_qty: item?.item_quantity ?? 0 }
                  //   : {}),
                  // item_min_max: item?.item_min_max,
                  item_total_amount: Number(item?.item_total_amount) || 0,
                  item_minimun_purchasing: item?.item_minimun_purchasing
                    ? parseInt(item?.item_minimun_purchasing)
                    : "",
                  item_maximum_purchasing: item?.item_maximum_purchasing
                    ? parseInt(item?.item_maximum_purchasing)
                    : "",
                  item_tax_amount: parseFloat(item?.item_tax_amount),
                  item_gst: parseFloat(item?.item_gst),
                  item_sgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_sgst || 0),
                  item_cgst: values?.is_inter_state === true ? 0 : parseFloat(item?.item_cgst || 0),
                  item_igst: values?.is_inter_state === true ? parseFloat(item?.item_igst || item?.item_tax_amount || 0) : 0,
                  item_uom_id: item?.item_uom_id ?? "",
                  item_hsn: item.item_hsn,
                })),
              },
              (data) => {
                successToast(data?.message);
                // setLoading(true);
                setTimeout(() => {
                  // setLoading(false);
                }, 50);
                navigate(
                  `/edit-customer-admin/${values?.cmr_id}?backto=/edit-purchase/${data?.data?.orderData?.pot_id}?new`,
                  {
                    state: { tab: "Address" },
                  }
                );
              },
              (data) => {
                errorToast(data?.data?.message);
                isDispatchingRef.current = false;
                setButtonLoading(false);
              }
            )
          );
        }
        else{
          navigate(
            `/edit-customer-admin/${values?.cmr_id}?backto=/add-purchase/%255B%255D/purchase?new`,
            {
              state: { tab: "Address" },
            }
          );
        }

      }
    }
  };
  const [gstType,setGstType]=useState(true);
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValue}
        validationSchema={validationSchema}
        onSubmit={(values, actions) => {
          // Block immediately and synchronously: only ONE submission can be
          // scheduled/in-flight at a time. Extra clicks before the backend
          // responds are ignored here, so they never queue another request.
          if (submitScheduledRef.current || isDispatchingRef.current) {
            actions.setSubmitting(false);
            return;
          }
          submitScheduledRef.current = true;
          setButtonLoading(true); // instant visual feedback / disable
          setTimeout(() => {
            submitScheduledRef.current = false;
            handleSubmit(values, actions); // arms isDispatchingRef on dispatch
            // If no dispatch happened (validation failed), re-enable the button.
            if (!isDispatchingRef.current) {
              setButtonLoading(false);
            }
            actions.setSubmitting(false); // Notify Formik that submission is done
          }, 1500);
        }}
      >
        {({ values, setFieldValue }) => {
          console.log(values, "fdgdgfdgfdgdfgdfg");

          setFormValues(values);
          return (
            <Form className="h-full">
              {toValidate&&<DirtyWatcher onChange={setEnableConfirm} />}
              <PurchaseCreditNotePanel
                page={page}
                open={creditNotesOpen}
                setOpen={setCreditNotesOpen}
              />
              <div
                style={{
                  height: `calc(100% - 8rem)`,
                }}
                className="mx-5 flex flex-col h-full "
              >
                <SalesPurchaseNavbar
                  isClone={isClone}
                  autoDraft={autoDraft}
                  clickedplus={clickedplus}
                  pageType={pageType}
                  page={page}
                  currentPage="purchase order"
                  loading={loading}
                  csvButtonText="Import CSV"
                  handleFileUpload={handleFileUpload}
                  importcsv={true}
                  section="purchase"
                  name="pot"
                  disabled={disabled}
                  searchRef={searchRef}
                  fetchCreditNoteFn={() => {
                    setCreditNotesOpen(true);
                  }}
                  docType="purchase_order"
                  storeDetails={storeDetails}
                  transfer={transfer}
                  standAlone={!transfer}
                  tempalteArray={[
                    {
                      documentType: "Purchase-order",
                      //
                      expectedHeaders: [
                        "item_name",
                        "item_sheet_uom",
                        "item_quantity",
                        "item_unit_price",
                        "item_total_price",
                        "item_baby_box_packing",
                        "molecule_name",
                        "mrp",
                        "item_batch_total_base_purchase_rate",
                        "item_discount_percentage",
                        "item_tax_percentage",
                      ],
                      //
                    },
                  ]}
                />
                {/* <PurchaseItemsSection
                  prefixName="gort"
                  disabled={disabled}
                  addBatchFn={(id) => {
                    setAddbatch(true);
                    setItemId(id);
                  }}
                  searchRef={searchRef}
                  initialData={initialData}
                /> */}

                <PurchaseOrderItemsSec
                  heading={heading}
                  disabled={values.is_inter_state===null || disabled}
                  searchRef={searchRef}
                  initialData={initialData}
                />
              </div>

              <SalesPurchaseFooter
                transaction="Purchase Order"
                transaction_type="purchase_order"
                buttonLoading={buttonLoading}
                name="pot_total_discount"
                page={page}
                disabled={disabled}
                prefixName="pot"
                EditFn={() =>
                  navigate(`/edit-purchase/${vendorDetails?.[0]?.pot_id}`)
                }
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default CreateEditViewPur;

//
